module.exports = __webpack_public_path__ + "img/digital05_mo.fec2d8b8.jpg";